import SVGAttributeSetter from './ma-icon-svg-attribute-setter';

export default {
    render(createElement) {
        return createElement('span');
    },
    props: {
        src: {
            type: String,
            required: true
        },
        inheritFillFromParent: {
            type: Boolean,
            default: true
        },
        assistiveText: {
            type: String
        },
        iconClass: {
            type: [Array, String]
        }
    },
    created() {
        const request = new XMLHttpRequest();

        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                // find the svg in the response
                const fragment = document.createRange().createContextualFragment(request.responseText);
                const svg = Array.from(fragment.childNodes).find(child => child.nodeName === 'svg');

                if (!svg) {
                    console.error('Could not build SVG.');
                    return;
                }

                SVGAttributeSetter.call(this, svg);
            } else {
                console.error(request);
            }
        };

        request.onerror = () => console.error('Could not load the SVG.');

        const { src } = this.$props;
        request.open('GET', src, true);
        request.send();
    }
};
